<ngx-spinner
  bdColor="rgba(51, 51, 51, 0.8)"
size="medium"
color="#white"
type="ball-spin-clockwise"
>
  <p class="loading-text">Загрузка...</p>
</ngx-spinner>
<app-install-notification></app-install-notification>
<p-toast key="global" position="top-right"></p-toast>
<p-toast
  key="app-update"
  position="top-right"
  styleClass="version-toast"
  [preventOpenDuplicates]="true"
  [showTransitionOptions]="'220ms cubic-bezier(0.16, 1, 0.3, 1)'"
  [hideTransitionOptions]="'180ms ease'"
>
  <ng-template let-message pTemplate="message">
    <div class="version-toast__body">
      <div class="version-toast__icon" aria-hidden="true">
        <i class="pi pi-sync"></i>
      </div>
      <div class="version-toast__text">
        <div class="version-toast__title">{{ message.summary }}</div>
        <div class="version-toast__detail" *ngIf="message.detail">{{ message.detail }}</div>
        <div class="version-toast__actions">
          <button
            type="button"
            class="version-toast__btn version-toast__btn--primary"
            (click)="onUpdateClick()"
          >
            <i class="pi pi-refresh"></i>
            <span>Обновить</span>
          </button>
          <button
            type="button"
            class="version-toast__btn version-toast__btn--ghost"
            (click)="onDismissUpdate(message)"
          >Позже</button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
<router-outlet></router-outlet>
